export default {
  "root": "_root_1e26k_1"
};import "ni:sha-256;SEDCLki68mWWX_hBEc0RqJ1P9BQF0OySc10ML7di5ww";